import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

export interface DetailSidePanelSectionProps {
  title: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  action?: React.ReactNode;
}

export const DetailSidePanelSection = ({
  title,
  icon,
  children,
  defaultOpen = true,
  className,
  action,
}: DetailSidePanelSectionProps) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div
      className={cn(
        "border border-border/80 rounded-xl overflow-hidden bg-card/50 shadow-xs",
        className,
      )}
    >
      <div className="w-full flex items-center justify-between px-4 py-3 bg-muted/40 transition-colors">
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex-1 flex items-center gap-2.5 text-[15px] font-semibold text-foreground cursor-pointer select-none text-left"
        >
          {icon}
          {title}
        </button>
        <div className="flex items-center gap-1">
          {action}
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="p-1 rounded hover:bg-muted text-muted-foreground hover:text-foreground cursor-pointer transition-colors"
            title={open ? "Recolher seção" : "Expandir seção"}
          >
            <ChevronDown
              className={cn(
                "w-4 h-4 text-muted-foreground transition-transform duration-200",
                open ? "rotate-0" : "-rotate-90",
              )}
            />
          </button>
        </div>
      </div>

      <div
        className={cn(
          "overflow-hidden transition-all duration-200",
          open
            ? "max-h-[3000px] opacity-100"
            : "max-h-0 opacity-0 pointer-events-none",
        )}
      >
        <div className="px-4 py-3.5 space-y-2.5">{children}</div>
      </div>
    </div>
  );
};
